
import { mapState } from 'vuex';

export default {
    name: 'WasteRemovalDetailsForm',
    props: {
        existingImages: {
            type: Array,
            default() {
                return [];
            },
        },
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            landTypes: [
                { name: this.$t('waste_removal.land_types.private'), slug: true, hint: this.$t('waste_removal.land_types.private_hint') },
                { name: this.$t('waste_removal.land_types.public'), slug: false, hint: this.$t('waste_removal.land_types.public_hint') },
            ],
        };
    },
    computed: {
        ...mapState(['auth']),
    },
    methods: {
        deleteImage(image) {
            /**
             * Delete image
             *
             * @type {object}
             */
            this.$emit('delete-image', image);
        },
        selectLandType(type) {
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.form.landType.$model = type;
        },
        submit() {
            if (this.form.validateFields(['description', 'landType'])) {
                this.$emit('submit');
            }
        },
    },
};
